/** Default MUI Snackbar position for the app. */
export const snackbarAnchorOrigin = { vertical: 'top', horizontal: 'center' };
